import qs from 'qs'
import { axios } from '@/utils/request'

const itemsApi = {
  //采购品目表
  queryPurchaseItems: '/api/1/expertmain/items/queryPurchaseItem',
  getNextLevelItemList: '/api/1/expertmain/items/getNextLevelItemList',
  getNextLevelItemListToAgent: '/api/1/expertmain/items/getNextLevelItemListToAgent',
}

//构建请求
/**
 * 分页查看采购品目数据
 * @param purchaseItems
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryPurchaseItems = (purchaseItems) => axios.get(itemsApi.queryPurchaseItems, { params: { ...purchaseItems } })

/**
 * 获取下一级品目
 * @param dto 参数
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetNextLevelItemList = (dto) => axios.get(itemsApi.getNextLevelItemList, { params: { ...dto } })

/**
 * 获取下一级品目(经办人用)
 * @param dto 参数
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetNextLevelItemListToAgent = (dto) => axios.get(itemsApi.getNextLevelItemListToAgent, { params: { ...dto } })



